import Vue from 'vue';
import Component from 'vue-class-component';
import { LoyaltySubscriptionStore } from '@/store/modules/Loyalty/Subscription/LoyaltySubscription'
import {
    ILoyaltySubscriptions,
    ILoyaltySubscriptionListItem,
} from '@/entity/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscription.types';
@Component
export class SubscriptionMix extends Vue {
    get loyaltySubscriptions(): ILoyaltySubscriptions | null {
        return LoyaltySubscriptionStore.loyaltySubscriptions;
    }
    get loyaltySubscription(): ILoyaltySubscriptionListItem | null {
        return LoyaltySubscriptionStore.loyaltySubscription;
    }
}